.toast {
    position: fixed;
    bottom: 10px;
    right: 10px;
    z-index: 99;
}

.toastHeaderSuccess,
.toastHeaderFailure {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.toastHeaderSuccess {
    background-color: #d4edda;
}

.toastHeaderSuccess > button,
.toastHeaderFailure > button {
    background-image: url('/btn_close.svg');
}
